<template>
  <!-- 投标保证金打款 -->
  <div class="deposit_payment_proposal">
    <div class="deposit_payment_first">
      <div class="deposit_payment_name">投标保证金打款</div>
      <div
        :class="'deposit_payment deposit_payment_' + dataObject.synergeticState"
      >
        {{ judgmentStatus(dataObject.synergeticState) }}
      </div>
    </div>
    <div style="padding-left: 5px">
      <el-form label-width="100px" label-position="left">
        <el-form-item label="招标意向：">
          <div>{{ dataObject.boxDepositVo.throwProjectName }}</div>
        </el-form-item>
        <el-form-item label="招标信息：">
          <div
            style="color: blue; text-decoration: underline; cursor: pointer"
            @click="openDetails"
          >
            查看招标信息详情
          </div>
        </el-form-item>
        <el-form-item label="保证金金额：">
          <div>{{ dataObject.boxDepositVo.depositFee }}</div>
        </el-form-item>
        <el-form-item label="任务接收人：">
          <div>
            <span
              v-for="(item, index) in dataObject.boxEmplList"
              style="margin-right: 6px"
              :key="index"
              >{{ item.trueName }}</span
            >
            <el-button
              type="warning"
              size="mini"
              v-if="
                dataObject.synergeticState !== 'YWC' &&
                dataObject.synergeticState !== 'YCH'
              "
              @click="increaseRecipient"
              >添加接收人</el-button
            >
          </div>
        </el-form-item>
        <el-form-item label="任务截至时间：" label-width="110px">
          <div>{{ dataObject.jobOverDate }}</div>
        </el-form-item>
        <el-form-item label="打款说明：" label-width="110px">
          <div>
            {{
              dataObject.boxDepositVo.payDesc
                ? dataObject.boxDepositVo.payDesc
                : "——"
            }}
          </div>
        </el-form-item>
        <el-form-item label="附件：" label-width="110px">
          <JYOssUploadFiles
            :file-list="dataObject.boxDepositVo.throwFileEntities1"
            statusIsEdit
          />
        </el-form-item>
        <el-form-item label="打款凭证：">
          <JYOssUploadFiles
            :file-list="dataObject.boxDepositVo.throwFileEntities"
            :accept="'.doc,.docx,.pdf,.xlsx,.xls,.png,.jpg,.jpeg'"
            :statusIsEdit="
              dataObject.synergeticState == 'YWC' ||
              dataObject.synergeticState == 'YCH'
            "
          />
        </el-form-item>
        <div style="text-align: center; margin-top: 20px">
          <el-button
            type="primary"
            v-if="
              dataObject.synergeticState !== 'YWC' &&
              dataObject.synergeticState !== 'YCH'
            "
            @click="confirmCompletion"
            >确认完成</el-button
          >
        </div>
      </el-form>
    </div>
    <!-- 添加接收人 -->
    <el-dialog
      title="添加接收人"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-form
        ref="recipientForm"
        :model="recipientForm"
        :rules="recipientRules"
        label-position="left"
        label-width="140px"
        class="demo-ruleForm"
      >
        <el-form-item label="接收人：" prop="employeeId">
          <el-select
            v-model="recipientForm.employeeId"
            filterable
            clearable
            placeholder="请选择接收人"
            style="width: 100%"
          >
            <el-option
              v-for="item in personnelList"
              :key="item.employeeId"
              :label="item.trueName"
              :value="item.employeeId + ',' + item.trueName"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div style="text-align: center; margin-top: 20px">
          <el-button type="primary" @click="submit('recipientForm')"
            >提交</el-button
          >
        </div>
      </el-form>
    </el-dialog>
    <!-- 招标信息详情 -->
    <el-dialog
      title="招标信息详情"
      :visible.sync="biddingInformationDialog"
      width="50%"
      :before-close="biddingInformationClose"
    >
      <el-row :gutter="20" class="bid-manage-card">
        <el-col :span="24">
          <b>招标意向标题：</b><span>{{ form.throwProjectName }}</span>
        </el-col>
        <el-col :span="24">
          <b>信息来源：</b>
          <span>
            {{
              form.infoFrom == "GGZYJYPT" ? "公共资源交易平台" : "内部资源"
            }},{{ form.infoFromText }}
          </span>
        </el-col>
        <el-col :span="6">
          <b>业务类型：</b>
          <span>
            {{ form.projectTypeSubName }}
          </span>
        </el-col>
        <el-col :span="6">
          <b>招标类型：</b>
          <span>
            {{
              throwTypeOptions.find((it) => it.throwTypeId == form.throwTypeId)
                ? throwTypeOptions.find(
                    (it) => it.throwTypeId == form.throwTypeId
                  ).throwTypeName
                : ""
            }}
          </span>
        </el-col>
        <el-col :span="12">
          <b>投标时间：</b>
          <span> {{ form.startDate + " ~ " + form.endDate }}</span>
        </el-col>
        <el-col :span="24">
          <b>招标人信息：</b>
          <el-card shadow="never">
            <el-row :gutter="30">
              <el-col :span="24">
                <b>招标人：</b>
                <span> {{ form.thrPeople }}</span>
              </el-col>
              <el-col :span="7">
                <b>联系人：</b>
                <span> {{ form.thrProxy }}</span>
              </el-col>
              <el-col :span="7">
                <b>联系电话：</b>
                <span> {{ form.thrProxyMobile }}</span>
              </el-col>
              <el-col :span="10">
                <b>电子邮件：</b>
                <span> {{ form.thrProxyEmail }}</span>
              </el-col>
              <el-col :span="24">
                <b>地址：</b>
                <span> {{ form.thrPeopleAddr }}</span>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="24">
          <b>招标代理机构信息：</b>
          <el-card shadow="never">
            <el-row :gutter="30">
              <el-col :span="24">
                <b>招标代理公司：</b>
                <span> {{ form.thrCompany }}</span>
              </el-col>
              <el-col :span="7">
                <b>联系人：</b>
                <span> {{ form.thrCompanyProxy }}</span>
              </el-col>
              <el-col :span="7">
                <b>联系电话：</b>
                <span> {{ form.thrCompanyProxyMobile }}</span>
              </el-col>
              <el-col :span="10">
                <b>电子邮件：</b>
                <span> {{ form.thrCompanyProxyEmail }}</span>
              </el-col>
              <el-col :span="24">
                <b>地址：</b>
                <span> {{ form.thrCompanyAddr }}</span>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="24">
          <b>招标范围及项目基本情况：</b>
          <p>{{ form.thrProjectInfo }}</p>
        </el-col>
        <el-col :span="24">
          <b>招标条件：</b>
          <p>{{ form.thrCondition }}</p>
        </el-col>
        <el-col :span="24">
          <b>投标要求及时间：</b>
          <p>{{ form.bidCondition }}</p>
        </el-col>
        <el-col :span="24">
          <b>备注说明：</b>
          <p>{{ form.commentDesc }}</p>
        </el-col>
        <el-col :span="24">
          <b>其他附件：</b>
          <p>
            <el-button
              type="text"
              v-for="item in form.throwFilePos"
              :key="item.filePath"
              @click.native="showFile(item.filePath)"
              style="text-decoration: underline"
              >{{ item.fileName }}</el-button
            >
          </p>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { ossShowFile, ossDownLoad, } from '@jy/utils/ossuploadfile'
import BoxFileList from '@/components/uploadfiel/boxFileList'
import { fileUpload } from '@/api/publiccommon'
import { addBoxEmpl, addFinish, projectInfo, throwType } from '@/api/bidBox'
export default {
  name: 'DepositPayment',
  components: {
    BoxFileList
  },
  computed: {

  },
  props: {
    dataObject: {
      type: Object,
      default: {},
      required: true
    },
    personnelList: {
      type: Array,
      default: {},
      required: true
    },
    btnauth: {
      type: Array,
      default: {},
      required: true
    },
  },
  data () {
    return {
      dialogVisible: false,
      recipientForm: {
        employeeId: '',
      },//接收人 表单提交
      recipientRules: {
        employeeId: [
          { required: true, message: '请选择接收人', trigger: 'change' }
        ]
      },
      biddingInformationDialog: false,//招标信息 弹窗 显示隐藏
      form: {},
      throwTypeOptions: [],//招标类型
    }
  },
  watch: {

  },
  created () {
    this.getThrowType()
  },
  mounted () {

  },
  methods: {
    showFile (path) {
      ossShowFile(path)
    },
    // 打开 添加接收人 表单
    increaseRecipient () {
      this.dialogVisible = true
    },
    // 提交接收人
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let arr = this.recipientForm.employeeId.split(',')
          let par = {
            boxId: this.dataObject.boxId,
            employeeId: arr[0],
            trueName: arr[1]
          }
          addBoxEmpl(par).then(res => {
            if (res.status === 200) {
              this.$message.success('接收人添加成功')
              this.recipientForm = {
                employeeId: '',
              }//接收人 表单提交
              this.$refs[formName].resetFields()
              this.$emit('renewList')
              this.dialogVisible = false
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    // 确认完成
    confirmCompletion () {
      if (this.dataObject.boxDepositVo.throwFileEntities.length === 0) {
        return this.$message.warning('请上传打款凭证！')
      } else {
        this.dataObject.boxDepositVo.throwFileEntities.forEach(item => {
          item.businessType = 'BZJ'
        })
      }
      this.$confirm('此操作将确认完成, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let par = {
          boxId: this.dataObject.boxId,
          businessId: this.dataObject.boxId,
          modleId: this.dataObject.modleId,
          modleType: this.dataObject.modleType,
          throwFileEntities: this.dataObject.boxDepositVo.throwFileEntities
        }
        addFinish(par).then(res => {
          if (res.status === 200) {
            this.$message.success('已确认完成')
            this.$emit('renewList')
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消确认完成'
        })
      })

    },
    // 关闭接收人 表单
    handleClose () {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.dialogVisible = false
          this.$refs['recipientForm'].resetFields()
        })
        .catch(_ => { })
    },
    // 打开招标详情 弹窗
    openDetails () {
      projectInfo(this.dataObject.boxDepositVo.throwProjectId).then(res => {
        if (res.status === 200) {
          this.form = res.data
          // this.form.startDate = new Date(this.form.startDate).format("yyyy-MM-dd hh:mm")
          // this.form.endDate = new Date(this.form.endDate).format("yyyy-MM-dd hh:mm")    
          this.biddingInformationDialog = true
        }
      })
    },
    // 关闭 招标详情 弹窗
    biddingInformationClose () {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.biddingInformationDialog = false
        })
        .catch(_ => { })
    },
    //招标类型
    getThrowType () {
      throwType().then(res => {
        if (res.status == 200) {
          this.throwTypeOptions = res.data || []
        }
      })
    },
    // 判断状态
    judgmentStatus (type) {
      if (type === 'DWC') {
        return '待完成'
      } else if (type === 'YWC') {
        return '已完成'
      } else if (type === 'YZF') {
        return '已作废'
      } else if (type === 'YCH') {
        return '已撤回'
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.deposit_payment_proposal {
  margin-bottom: 20px;
  padding: 20px;
  border: 1px solid #06ee82;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  .deposit_payment_first {
    display: flex;
    justify-content: space-between;
    .deposit_payment_name {
      margin-bottom: 20px;
      font-size: 16px;
      font-weight: 700;
    }
    .deposit_payment {
      height: 32px;
      padding: 0 10px;
      line-height: 30px;
      font-size: 12px;
      border-style: solid;
      border-radius: 4px;
      box-sizing: border-box;
      white-space: nowrap;
    }
    .deposit_payment_YWC {
      color: #026235;
      border: 1px solid #00f985;
      background: #b9e9d3;
    }
    .deposit_payment_DWC {
      color: #a10303;
      border: 1px solid #a10303;
      background: #f0a7a7;
    }
    .deposit_payment_YCH {
      color: #909399;
      border: 1px solid #909399;
      background: #f4f4f5;
    }
  }
}
::v-deep .el-form-item {
  margin-bottom: 0 !important;
}
.bid-manage-card {
  margin: 40px 60px !important;
  font-size: 14px;
  line-height: 28px;
  .el-col {
    margin: 10px 0 !important;
  }
  .el-card {
    margin: 10px 0;
  }
  span,
  p {
    font-size: 14px;
  }
  u {
    color: #409eff;
    cursor: pointer;
  }
}
::v-deep .text-ellipsis {
  max-width: 9vw;
}
</style>
